<template>
  <div class="system-fields-group">
    <div class="title">
      <span>{{ systemGroup.name }}</span>
    </div>
    <div class="field-list">
      <div
        v-for="field in systemGroup.fields"
        :key="field._cid || field.code"
        class="field-box"
        :class="{
          'is-active': field._cid == activeControlCid || field.code == activeControlCid
        }"
        @click="changeSystemControl(field)"
      >
        <div class="field-label" v-tip>
          <svg-icon v-if="hiddenCids.includes(field._cid)" icon-class="svgo_hide"></svg-icon>
          {{ field.name }}
        </div>
        <div class="field-value"></div>
        <el-tooltip
          v-if="!hiddenCids.includes(field._cid)"
          effect="dark"
          content="隐藏"
          placement="right-end"
        >
          <span class="hide-field" @click="changeVisible(field, false)">
            <svg-icon icon-class="svgo_hide"></svg-icon>
          </span>
        </el-tooltip>
        <el-tooltip v-else effect="dark" content="显示" placement="right-end">
          <span class="hide-field">
            <i
              class="el-icon-view"
              @click="changeVisible(field, true)"
              style="font-weight: bold"
            ></i>
          </span>
        </el-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import { systemGroup } from "@/views/Backend/AdminEdit/Sheet/Field/static"

export default {
  name: "system-fields-group",
  props: {
    activeControlCid: String,
    hiddenCids: Array
  },
  data() {
    return {
      systemGroup
    }
  },
  methods: {
    changeVisible(field, isShow) {
      this.$emit("hideSystemField", field, isShow)
    },
    changeSystemControl(control) {
      this.$emit("openSetting", { type: "system-field", control: control })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/mixins.scss";

.system-fields-group {
  &:hover {
    border-style: dashed;
    border-color: #ff8000;
  }
  .title {
    font-weight: bold;
  }
  .field-list {
    height: 100%;
    width: 100%;
    min-height: 100px;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    justify-content: space-between;
    padding: 12px 8px;
    margin-top: 10px;
    box-sizing: border-box;
    border: 1px solid #dee1e6;
    border-radius: 4px;
    ::v-deep {
      .field-box {
        display: flex;
        align-items: center;
        width: calc(50% - 20px);
        padding: 12px;
        margin-bottom: 8px;
        border-radius: 4px;
        box-sizing: border-box;
        height: 50px;
        cursor: grab;
        position: relative;
        &:hover {
          background-color: #f4f5f7;
          .hide-field {
            opacity: 1;
            &:hover {
              background-color: red;
              border-color: red;
            }
          }
        }
        &.is-active {
          background-color: #e3f3ff;
        }
      }
    }
    .field-label {
      @include ellipsis;
      display: inline-block;
      width: 25%;
      min-width: 75px;
      padding-left: 6px;
      height: 24px;
      line-height: 24px;
      margin-right: 8px;
      box-sizing: border-box;
    }
    .field-value {
      display: flex;
      flex: auto;
      height: 30px;
      line-height: 24px;
      box-sizing: border-box;
      padding: 0 8px;
      border: 1px solid #dee1e6;
      border-radius: 4px;
      background-color: #ebedf2;
    }
    .hide-field {
      position: absolute;
      padding: 1px;
      opacity: 0;
      right: -4px;
      top: -4px;
      transition: all 0.2s;
      color: #fff;
      background-color: #909399;
      border-color: #909399;
      border-radius: 50%;
      width: 16px;
      height: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>
